export const MOBILE_MAX_WIDTH = 767;

export const DESKTOP_MIN_WIDTH = 768;
